import { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TaskProvider } from "./app/context/TaskContext";
import "./styles/globals.css";

// Lazy load components
const Layout = lazy(() => import("./app/components/ui/Layout"));
const HomePage = lazy(() => import("./landing/views/HomePage"));
const TaskPage = lazy(() => import("./app/views/TaskPage"));

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Suspense fallback={null}>
      <TaskProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/task" element={<Layout />}>
            <Route index element={<TaskPage />} />
            <Route path=":taskID" element={<TaskPage />} />
          </Route>
        </Routes>
      </TaskProvider>
    </Suspense>
  </BrowserRouter>,
);
